var map = {
	"./3d-rotation.svg": 60001,
	"./3d.svg": 64594,
	"./3dPrinter.svg": 33574,
	"./3dPrinterSuccess.svg": 80887,
	"./approval.svg": 10374,
	"./arrow-left.svg": 65648,
	"./arrow-right-square-fill.svg": 88865,
	"./automated.svg": 70787,
	"./automaticDesign.svg": 77122,
	"./automaticDesignSelected.svg": 23149,
	"./bag.svg": 83351,
	"./barcode.svg": 70769,
	"./battery-low.svg": 19419,
	"./blob.svg": 87010,
	"./blocked.svg": 2085,
	"./box-seam.svg": 97029,
	"./box.svg": 2474,
	"./bullet.svg": 91127,
	"./caffe.svg": 80792,
	"./calendario.svg": 44521,
	"./caret-down-dark.svg": 86102,
	"./caret-down.svg": 21149,
	"./caret-up-dark.svg": 19283,
	"./caret-up.svg": 61058,
	"./change-test.svg": 87680,
	"./characterization/dente-inf.svg": 79187,
	"./characterization/dente-med.svg": 18780,
	"./characterization/dente-sup.svg": 77114,
	"./chat/caret-down.svg": 31178,
	"./chat/caret-up.svg": 3417,
	"./chat/chat.svg": 49314,
	"./chat/qr-code.svg": 70021,
	"./check-circle-fill-green.svg": 34266,
	"./check-circle-fill-violet.svg": 55476,
	"./check-circle-green.svg": 39860,
	"./check-circle.svg": 92670,
	"./check-white.svg": 92533,
	"./check.svg": 82497,
	"./checkbox-checked-violet.svg": 56144,
	"./checkbox-checked.svg": 22276,
	"./checkbox.svg": 40548,
	"./chevron-down.svg": 79573,
	"./chevron-left-violet.svg": 48486,
	"./chevron-up.svg": 15738,
	"./clock-black.svg": 4117,
	"./clock.svg": 92075,
	"./close-circle-fill-red.svg": 67318,
	"./close-circle-fill.svg": 35876,
	"./close-circle-red.svg": 49768,
	"./close-circle-white.svg": 41478,
	"./close-circle.svg": 49866,
	"./close-white.svg": 33025,
	"./close.svg": 35837,
	"./consulting/pause.svg": 23920,
	"./consulting/pending-violet.svg": 98421,
	"./consulting/question.svg": 52626,
	"./copy-purple.svg": 87471,
	"./copy.svg": 28552,
	"./danger.svg": 40950,
	"./dash.svg": 5395,
	"./dente inf-04.svg": 67173,
	"./dente med-03.svg": 9723,
	"./dente sup-02.svg": 38748,
	"./dente_16.svg": 49729,
	"./dente_17.svg": 37488,
	"./dente_18.svg": 14055,
	"./department.svg": 71561,
	"./digital-label.svg": 41676,
	"./dislike-red.svg": 82506,
	"./dislike-white.svg": 54528,
	"./dislike-yellow.svg": 10497,
	"./dislike.svg": 11536,
	"./dottore.svg": 14096,
	"./download-cloud.svg": 79275,
	"./download-violet.svg": 52833,
	"./download.svg": 91303,
	"./edit.svg": 975,
	"./external-link-violet.svg": 65825,
	"./externalPrimoup.svg": 6950,
	"./filter.svg": 87985,
	"./flag.svg": 41113,
	"./furgone.svg": 30443,
	"./gear-violet.svg": 69806,
	"./geo-alt.svg": 17384,
	"./global-notes.svg": 82150,
	"./grade-a-plus.svg": 1127,
	"./grip-vertical.svg": 76570,
	"./heart-selected.svg": 27301,
	"./heart.svg": 49733,
	"./history.svg": 13185,
	"./iso-in/accept.svg": 75141,
	"./iso-in/changed-test.svg": 78440,
	"./iso-in/custom.svg": 8576,
	"./iso-in/fork-right.svg": 80340,
	"./iso-in/reassign.svg": 44137,
	"./iso-in/refuses.svg": 41276,
	"./iso-in/suspend.svg": 67515,
	"./jump-link.svg": 32972,
	"./lavorazione.svg": 39997,
	"./like-green.svg": 81700,
	"./like.svg": 45998,
	"./link-slash.svg": 43979,
	"./link-to.svg": 18395,
	"./logistic-checkin/3d-rotation.svg": 55866,
	"./logistic-checkin/calendar.svg": 54692,
	"./logistic-checkin/customer.svg": 48894,
	"./logistic-checkin/dental-chair.svg": 82558,
	"./logistic-checkin/doctor.svg": 20175,
	"./logistic-checkin/gem.svg": 1907,
	"./logistic-checkin/keyboard.svg": 22981,
	"./logistic-checkin/scanner-barcode.svg": 13583,
	"./logistic-checkin/van.svg": 5129,
	"./logistic-checkin/vertical-dots.svg": 46473,
	"./logistic-checkin/wrench.svg": 18025,
	"./logout.svg": 34277,
	"./manager/bell.svg": 47584,
	"./manager/change-test.svg": 25852,
	"./manager/chevron-left.svg": 63762,
	"./manager/chevron-right.svg": 15145,
	"./manager/chevron-rigth-violet.svg": 57095,
	"./manager/circle-selected.svg": 87991,
	"./manager/circle.svg": 95723,
	"./manager/faild.svg": 82849,
	"./manager/forward-clinic.svg": 30999,
	"./manager/gears.svg": 98381,
	"./manager/reassign.svg": 1635,
	"./manager/resume-orange.svg": 52033,
	"./manager/resume.svg": 52062,
	"./manager/sent-mail.svg": 85095,
	"./media/check-circle.svg": 13477,
	"./media/close-circle.svg": 33457,
	"./media/pause.svg": 21870,
	"./media/play.svg": 18878,
	"./media/stop.svg": 31192,
	"./millingCenter.svg": 47472,
	"./mobile/chat.svg": 18062,
	"./mobile/details.svg": 19742,
	"./mobile/home.svg": 21009,
	"./mobile/orders.svg": 10439,
	"./mobile/projects.svg": 55706,
	"./model/arch/arch-inf-plus.svg": 31011,
	"./model/arch/arch-inf-sel.svg": 64629,
	"./model/arch/arch-inf.svg": 39930,
	"./model/arch/arch-sup-plus.svg": 75236,
	"./model/arch/arch-sup-sel.svg": 67476,
	"./model/arch/arch-sup.svg": 32315,
	"./model/arch/base-arch-plus.svg": 60497,
	"./model/arch/base-arch-sel.svg": 76727,
	"./model/arch/base-arch.svg": 3768,
	"./model/bar/bar-plus.svg": 58931,
	"./model/bar/bar-sel.svg": 52261,
	"./model/bar/bar.svg": 41098,
	"./model/bracket/bracket-plus.svg": 49859,
	"./model/bracket/bracket-sel.svg": 99189,
	"./model/bracket/bracket.svg": 53754,
	"./model/checkbox.svg": 34918,
	"./model/custom-pin/custom-pin-plus.svg": 84235,
	"./model/custom-pin/custom-pin-sel.svg": 16813,
	"./model/custom-pin/custom-pin.svg": 67794,
	"./model/gig/gig-plus.svg": 27675,
	"./model/gig/gig-sel.svg": 11197,
	"./model/gig/gig.svg": 85378,
	"./model/gum/gum-plus.svg": 93075,
	"./model/gum/gum-sel.svg": 33317,
	"./model/gum/gum.svg": 18717,
	"./model/milling/milling-sel.svg": 27021,
	"./model/stump/stump-plus.svg": 51099,
	"./model/stump/stump-sel.svg": 17437,
	"./model/stump/stump.svg": 14850,
	"./molding.svg": 90357,
	"./more-info.svg": 44973,
	"./move-up.svg": 21534,
	"./note.svg": 59667,
	"./pause.svg": 51947,
	"./paziente.svg": 53329,
	"./pencil.svg": 50184,
	"./pending.svg": 87352,
	"./play-outline-green.svg": 57130,
	"./play-outline-white.svg": 55600,
	"./play-outline.svg": 6848,
	"./play.svg": 10757,
	"./playlist-add.svg": 5151,
	"./plus-circle-fill.svg": 53858,
	"./plus-violet.svg": 26189,
	"./plus-white.svg": 36891,
	"./poltrona_dentista.svg": 35639,
	"./prescription.svg": 22675,
	"./printer-black.svg": 85031,
	"./printer-white.svg": 10557,
	"./printer.svg": 89049,
	"./project/arch/arch-inf-sel.svg": 24681,
	"./project/arch/arch-inf.svg": 67622,
	"./project/arch/arch-sup-sel.svg": 53008,
	"./project/arch/arch-sup.svg": 36127,
	"./project/bridge/bridge-sel.svg": 10953,
	"./project/bridge/bridge.svg": 55078,
	"./project/emiarch/emiarch-1-sel.svg": 52747,
	"./project/emiarch/emiarch-1.svg": 93716,
	"./project/emiarch/emiarch-2-sel.svg": 15384,
	"./project/emiarch/emiarch-2.svg": 41927,
	"./project/emiarch/emiarch-3-sel.svg": 86329,
	"./project/emiarch/emiarch-3.svg": 78102,
	"./project/emiarch/emiarch-4-sel.svg": 50390,
	"./project/emiarch/emiarch-4.svg": 34489,
	"./project/mouth/mouth-sel.svg": 26137,
	"./project/mouth/mouth.svg": 72502,
	"./project/sest/sest-1-sel.svg": 16495,
	"./project/sest/sest-1.svg": 2224,
	"./project/sest/sest-2-sel.svg": 53916,
	"./project/sest/sest-2.svg": 59267,
	"./project/sest/sest-3-sel.svg": 3085,
	"./project/sest/sest-3.svg": 44626,
	"./project/sest/sest-4-sel.svg": 18194,
	"./project/sest/sest-4.svg": 78557,
	"./project/sest/sest-5-sel.svg": 12115,
	"./project/sest/sest-5.svg": 89084,
	"./project/sest/sest-6-sel.svg": 7904,
	"./project/sest/sest-6.svg": 68111,
	"./puntini.svg": 73262,
	"./save-outline-violet.svg": 53067,
	"./scan-done.svg": 57229,
	"./scan.svg": 30124,
	"./search-violet.svg": 92529,
	"./search-white.svg": 12631,
	"./search.svg": 64343,
	"./shipping-code.svg": 25017,
	"./shopping-cart-add.svg": 30436,
	"./shopping-cart.svg": 5302,
	"./situ/scan-3d.svg": 87746,
	"./skip.svg": 99178,
	"./sospendi.svg": 21116,
	"./special/exclamation-circle.svg": 91779,
	"./special/question.svg": 37955,
	"./switch-user.svg": 12097,
	"./sync.svg": 38906,
	"./tecnico.svg": 79024,
	"./telegram-violet.svg": 54502,
	"./telegram-white.svg": 41306,
	"./termina.svg": 78585,
	"./trash-violet.svg": 11901,
	"./update.svg": 69728,
	"./upload-video.svg": 1918,
	"./upload-violet.svg": 21436,
	"./upload.svg": 50600,
	"./user.svg": 10698,
	"./van.svg": 44018,
	"./view-list.svg": 86697,
	"./waiting-for-approval.svg": 57830,
	"./warehouse.svg": 23552,
	"./warning.svg": 42865,
	"./x-circle-fill-violet.svg": 51308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;